import { styled } from '@abyss/web/tools/styled';
import { Button } from '@abyss/web/ui/Button';
import { Flex } from '@abyss/web/ui/Flex';

export const ChoosePCPCardContainer = styled(Flex, {
  minHeight: '313px',
  gap: '8px',
  border: ' 1px dashed $lightGrey',
  padding: '32px 16px',
  borderRadius: '8px',
  flexWrap: 'nowrap',
  '.abyss-flex-root': {
    textAlign: 'center',
  },

  '@screen >= $md': {
    width: '282px',
  },
  '@screen < $md': {
    display: 'flex',
    width: '90%',
    marginBottom: '20px',
  },
});

export const CareTeamEmptyCardContainer = styled(Flex, {
  display: 'flex',
  minHeight: '313px',
  gap: '8px',
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.12)',
  border: ' 1px solid $lightGrey',
  padding: '12px 60px',
  borderRadius: '8px',
  flexWrap: 'nowrap',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  '@screen >= $md': {
    flex: 1,
  },
  '@screen < $md': {
    marginLeft: '0px',
    width: '90%',
    flexDirection: 'column',
    margin: '12px 60px',
    padding: '50px 60px',
  },
});

export const CareTeamEmptyCardStyle = styled('div', {
  display: 'flex',
  flexWrap: 'nowrap',
  alignItems: 'center',
  '@screen >= $md': {
    flex: 1,
    justifyContent: 'space-around',
  },
  '@screen < $md': {
    marginLeft: '0px',
    flexDirection: 'column-reverse',
  },
});

export const CareTeamEmptyCardHeader = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  '@screen >= $md': {},
  '@screen < $md': {
    marginTop: '20px',
    width: '95%',
    textAlign: 'center',
  },
});

export const CareTeamEmptyCardData = styled('div', {
  '@screen < $md': {
    marginBottom: '25px',
  },
});

export const CareProviderImage = styled('div', {
  width: '70px',
  height: '70px',
  margin: '0px 16px',
  backgroundColor: '$snackCardAvatarBackgroundColor',
  borderRadius: '50%',
  border: '1px solid #F3F3F3',
  overflow: 'hidden',
  '@screen < $sm': { width: '55px', height: '55px', margin: '0px 8px' },
});

export const CareProviderContainer = styled('div', {
  dynamic: ({ cssProps: { index } }) => ({
    flexDirection: 'row',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: index !== 0 ? '20px' : '0px',
  }),
});

export const CareTeamSkeleton = styled('div', {
  variants: {
    size: {
      md: {
        background: '$lightGrey2',
        width: '150px',
        height: '10px',
        marginTop: '3px',
        marginBottom: '15px',
        borderRadius: '20px',
      },
      lg: {
        background: '$lightGrey2',
        marginTop: '5px',
        minWidth: '200px',
        height: '10px',
        borderRadius: '20px',
        '@screen < $sm': {
          minWidth: '150px',
        },
      },
    },
  },
});

export const InfoPopoverContainerStyle = {
  listStyle: 'disc',
  paddingLeft: '20px',
  paddingRight: '10px',
  fontSize: '14px',
  lineHeight: '20px',
  margin: '20px 0',
};

export const InfoPopoverListStyle = {
  fontSize: '14px',
  lineHeight: '18px',
  marginBottom: '4px',
};

export const InfoIconStyle = {
  'abyss-icon-material': {
    marginBottom: '-3.5px',
    marginLeft: '2px',
  },
};

export const ChoosePCPButton = styled(Button, {
  fontSize: '$md',
  fontWeight: '$semibold',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  '&.abyss-button-root': {
    width: '180px',
    height: '36px',
  },
});

export const ChoosePCPCnsOrIFP = styled('p', {
  lineHeight: '20px',
  fontWeight: '400',
  fontStyle: 'normal',
  fontSize: '16px',
  textAlign: 'center',
  color: '$black30',
  marginBottom: '10px',
});
